// extracted by mini-css-extract-plugin
export default {"speech-container":"styles_speech-container__DCSsE"};